












import { VueCustom } from 'vue-custom';
import { WorkspaceElement } from 'types';
import AnimationManager from 'managers/animation.manager';

import Box from 'components/base-box.vue';

export default VueCustom.extend({
  name: 'final-box',
  props: {
    data: Object as PropType<WorkspaceElement>,
    type: String as PropType<'final' | 'exhausted'>,
  },
  components: {
    Box,
  },
  computed: {
    id(): WorkspaceElement['elementId'] {
      return this.data.elementId;
    },
    isFinal(): boolean {
      return this.type === 'final';
    },
    isExhausted(): boolean {
      return this.type === 'exhausted';
    },
    isFinalAnimationActive(): boolean {
      return this.$store.getters.isFinalForIdActive(this.id);
    },
    isExhaustedAnimationActive(): boolean {
      return this.$store.getters.isExhaustedForIdActive(this.id);
    },
    classes(): Record<string, boolean> {
      return {
        'js-final': !this.isFinalAnimationActive && !this.isExhaustedAnimationActive,
        'js-exhausted': this.isExhausted,
      };
    },
  },
  methods: {
    onClick() {
      if (this.isFinal) {
        this.onFinalClick();
      } else {
        this.onExhaustedClick();
      }
    },
    onFinalClick() {
      AnimationManager.startFinal(this.id);
    },
    onExhaustedClick() {
      AnimationManager.startExhausted(this.id);
    },
  },
});
